<template>
	<AsiDialogFormLayout v-if="model !== null" :icon="icons.description" :title="$t('item.longDescription')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>

		<v-card-text class="pa-0">
			<v-form v-model="valid">
				<div class="pa-6 d-flex justify-center">
					<v-btn-toggle v-model="locale" mandatory>
						<AsiBtn v-for="curLocale in availableLocales" :key="curLocale.value" :value="curLocale.value" small>
							{{ curLocale.text }}
						</AsiBtn>
					</v-btn-toggle>
				</div>
				<div class="px-6 pb-6">
					<AsiMarkDownEditor v-model="model.longDescription[currentLocaleExtracted]" :label="$t('item.longDescription')"/>
				</div>
			</v-form>
		</v-card-text>

	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogFormLayout from "../../common/AsiDialogFormLayout.vue";
	import TranslatedValueFormPart from "../../translated-value/admin/TranslatedValueFormPart.vue";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";
	import ItemUpdateBasicData from "../../../models/item/ItemUpdateBasicData";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiMarkDownEditor from "@/components/common/AsiMarkDownEditor.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import {TranslateResult} from "vue-i18n";
	import LocaleHelper from "@/helpers/LocaleHelper";

	@Component({
		components: {AsiBtn, AsiMarkDownEditor, TranslatedValueFormPart, AsiDialogFormLayout}
	})
	export default class ItemUpdateDialogLongDescription extends AsiDialogForm {
		@Prop({type: Object, required: true})
		public item!: IItemAdmin;

		private model: ItemUpdateBasicData | null = null;
		private locale = this.$i18n.locale;

		@Watch('item', {deep: true, immediate: true})
		private onItemChanged(): void {
			this.setItemInternal();
		}

		@Emit('save')
		public save(): void {
			if (this.model?.longDescription !== undefined) {
				this.item.longDescription = this.model.longDescription;
			}
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.setItemInternal();
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		private get availableLocales(): { text: string | TranslateResult, value: string }[] {
			return LocaleHelper.supportedLocaleOptions();
		}

		private get currentLocaleExtracted(): string {
			return LocaleHelper.extractLanguage(this.locale);
		}

		private setItemInternal(): void {
			if (this.model === null) {
				this.model = new ItemUpdateBasicData(this.item);
				this.valid = true;
			} else {
				this.model.setDetailModel(this.item);
			}
		}

		private requestSave(): void {
			if (this.model === null) return;

			this.loading = true;
			this.$itemServiceAdmin.updateBasicData(this.item.id, this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}
	}
</script>

<style lang="scss" scoped>

</style>
